import { render } from "./ClientLogsDashboard.vue?vue&type=template&id=4fd0ebf4&scoped=true"
import script from "./ClientLogsDashboard.vue?vue&type=script&lang=js"
export * from "./ClientLogsDashboard.vue?vue&type=script&lang=js"

import "./ClientLogsDashboard.vue?vue&type=style&index=0&id=4fd0ebf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd0ebf4"]])

export default __exports__